import { Pipe, PipeTransform } from '@angular/core';

@Pipe({standalone: true, name: 'groupedMeasureValues'})
export class GroupedMeasureValuesPipe implements PipeTransform {

    constructor() {}

    public transform(measuresIndexed: Object, keys: []): any[] {
        if (!measuresIndexed)
            return [];

        const measures = keys.filter((key) => {
            return key in measuresIndexed;
        }).map((key) => {
            return measuresIndexed[key];
        })

        return measures;
    }
}
